import { render } from "./RekionTopPage.vue?vue&type=template&id=1e18cab0&scoped=true&ts=true"
import script from "./RekionTopPage.vue?vue&type=script&lang=ts"
export * from "./RekionTopPage.vue?vue&type=script&lang=ts"

import "./RekionTopPage.vue?vue&type=style&index=0&id=1e18cab0&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e18cab0"]])

export default __exports__